import { useState } from "react";
import BreadCrumb from "../../components/Breadcrumb";
import CustomListTab from "./CustomListTab";
import FavoriteListTab from "./FavoriteListTab";
const Formula = () => {
  const [activeSection, setActiveSection] = useState(0);
  return (
    <div className="patients-page">
      <BreadCrumb pageName="Your Formulas" />
      <div className="row">
        <div className="col-sm-12">
          <h3 className="page-title">Your Formulas</h3>
          <p className="page-desc">View your Custom Formulas.</p>
          <div className="row">
            {/* <div className="tab-wrapper">
              <div
                className={`tab ${activeSection === 0 ? "selected" : ""}`}
                onClick={() => setActiveSection(0)}
              >
                {" "}
                <h2>Custom</h2>
              </div>
              <div
                className={`tab ${activeSection === 1 ? "selected" : ""}`}
                onClick={() => setActiveSection(1)}
              >
                <h2>Favorites</h2>
              </div>
            </div>
            <div className="col-sm-12">
              <div className="detail-wrapper">
                {activeSection === 0 && <CustomListTab />}
                {activeSection === 1 && <FavoriteListTab />}
              </div>
            </div> */}
            <div className="col-sm-12">
              <CustomListTab />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Formula;
